import { render } from "./AnswerPanel.vue?vue&type=template&id=ae66c9f2"
import script from "./AnswerPanel.vue?vue&type=script&lang=js"
export * from "./AnswerPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__